module.exports = __webpack_public_path__ + "static/media/map.df1b2b5e.svg";